import { useMemo } from 'react';
import { TableColumn as TableColumnWSR } from '@wix/design-system/dist/types/Table';

export interface UseActionsCellColumnBaseParams<T> {
  actionsCellWidth?: string | number;
  actionsCellProps?: Partial<Omit<TableColumnWSR<T>, 'render' | 'style'>>;
}

export function useActionsCellColumnBase<T>(
  params: UseActionsCellColumnBaseParams<T>,
) {
  const { actionsCellProps, actionsCellWidth } = params;

  return useMemo(() => {
    return {
      title: '',
      id: 'cairo-actions-cell',
      key: 'cairo-actions-cell',
      width: actionsCellWidth ?? '48px',
      style: { justifyContent: 'flex-end' },
      ...actionsCellProps,
    };
  }, [actionsCellProps, actionsCellWidth]);
}
